import { createContext, ReactElement, useEffect } from 'react';
import { SignOut } from '@aws-amplify/ui-react/dist/types/components/Authenticator/Authenticator';
import { useProfile } from '../hooks/useProfile';
import { useSingletonSessions } from '../hooks/useSingletonSessions';
import { User } from '../types/user';

type UserContextType = [User, SignOut];
const UserContext = createContext<UserContextType | null>(null);
UserContext.displayName = 'UserContext';

interface UserProviderProps {
  children: ReactElement;
  signOut: SignOut;
}

export default function UserProvider({ children, signOut }: UserProviderProps): ReactElement {
  const { data, error } = useProfile();

  // Proactively cache singleton sessions after user profile is loaded
  // Only call when team_id is available to prevent multiple calls
  useSingletonSessions(data?.team_id || undefined);

  useEffect(() => {
    if (error) {
      signOut({ global: true });
    }
  }, []);

  return (
    <UserContext.Provider value={[data, signOut]} {...{ children }}>
      {data ? children : null}
    </UserContext.Provider>
  );
}

export { UserContext };
export type { UserContextType };
